import React from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./Home.module.scss";
import PillButton from "../../../components/PillButton";
import FormCard from "../../../components/FormCard";
import logo from "../../../static/images/Logo.png";

const Home = () => {
  const navigate = useNavigate()
  return (
    <div className={classes.container}>
      <img src={logo} alt="Logo" className={classes.logo} />
      <FormCard>
        <h3 className={classes.title}>Welcome to Sapu</h3>
        <p className={classes.description}>
          Press the button below to get started with Sapu.
        </p>
        <PillButton className={classes.getStartedButton} onClick={() => { navigate('/login') }}>Get Started</PillButton>
      </FormCard>
    </div>
  );
};

export default Home;
